/**
 * Simple hook to get current project configuration
 */

import { useState, useEffect, useMemo } from 'react';
import { getSettings } from '../utils/settings';
import { getProjectConfig, ProjectConfig, PVQ_PROJECT } from '../projects/projectConfig';

export function useProjectConfig(): ProjectConfig {
  const [settings, setSettings] = useState(getSettings());

  // Listen for settings changes
  useEffect(() => {
    const handleSettingsChange = () => {
      setSettings(getSettings());
    };

    // Listen for storage changes (when settings are updated in another tab or component)
    window.addEventListener('storage', handleSettingsChange);

    // Custom event for same-tab settings changes
    window.addEventListener('pvq-settings-changed', handleSettingsChange);

    return () => {
      window.removeEventListener('storage', handleSettingsChange);
      window.removeEventListener('pvq-settings-changed', handleSettingsChange);
    };
  }, []);

  const config = useMemo(() => {
    const projectConfig = getProjectConfig(settings.selectedProjectId);
    // Default to PVQ.ai if no project selected (backward compatibility)
    return projectConfig || PVQ_PROJECT;
  }, [settings.selectedProjectId]);

  return config;
}
